import { Flex } from "@mantine/core";

import { useStatsDrawer } from "../hooks/useStatsDrawer";
import { useWidgetVisibility } from "../hooks/useWidgetVisibility";
import { StatsDrawer } from "./StatsDrawer";
import styles from "./WidgetContainer.module.css";
import { WidgetPanel } from "./WidgetPanel";

export function WidgetContainer() {
    const {
        shouldHideWidgetContainer,
        showLeftPanel,
        showStatsHeader,
        showChallenges,
        hasLeaderboards,
        leaderboards,
        isExpertPerformanceDashboardEnabled,
        isChecklistSummaryEnabled,
        showTrophyCase,
    } = useWidgetVisibility();
    const drawer = useStatsDrawer();

    if (shouldHideWidgetContainer) return undefined;

    const handleStatsHeaderClick = () => {
        drawer.toggle("PayWidget", showStatsHeader);
    };

    const handleDrawerClose = () => {
        drawer.handleClose("CloseButton");
    };

    return (
        <Flex flex={1} className={styles.main} bg="dark.8" w={"100%"}>
            {showLeftPanel && (
                <WidgetPanel
                    opened={drawer.opened}
                    showStatsHeader={showStatsHeader}
                    showChallenges={showChallenges}
                    hasLeaderboards={hasLeaderboards}
                    leaderboards={leaderboards}
                    onStatsHeaderClick={handleStatsHeaderClick}
                />
            )}

            {isExpertPerformanceDashboardEnabled && (
                <StatsDrawer
                    opened={drawer.opened}
                    onClose={handleDrawerClose}
                    showChecklistSummary={isChecklistSummaryEnabled}
                    showTrophyCase={showTrophyCase}
                />
            )}
        </Flex>
    );
}
